
import { Routes, Route, Navigate } from 'react-router-dom'
import { ToastContainer } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import { LanguageProvider } from './contexts/LanguageContext'
import { Toaster } from './components/ui/toaster'
import Login from './app/login/page'
import Register from './app/register/page'
import Dashboard from './app/dashboard/page'
import Profile from './app/profile/page'

import Home from './app/page'
import Marketplace from './app/marketplace/page'
import ToolDetail from './app/marketplace/[id]/page'
import Contact from './app/contact/page'
import Agent from './app/agent/page'
import AgentDetail from './app/agent/[id]/page'
import JCMDTest from './components/JCMDTest'

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/profile" element={<Profile />} />

          <Route path="/agent" element={<Agent />} />
          <Route path="/agent/:id" element={<AgentDetail />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/marketplace" element={<Marketplace />} />
          <Route path="/marketplace/:id" element={<ToolDetail />} />
          <Route path="/jcmd-test" element={<JCMDTest />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
        <Toaster />
      </div>
    </LanguageProvider>
  )
}

export default App 